import { Button, Icon, Spacing, TextInput } from 'zens-storybook'
import React, { Suspense, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { AccessType } from 'zens-store'
import { useNumberParams, Link } from 'zens-router'
import { useBreadcrumb, usePermissions } from '@dms/hook'
import { Grid, LayoutHeader, ScheduleCard, ScheduleGrid } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  header: {
    flexDirection: 'row',
  },
  search: {
    minWidth: 300,
    marginRight: Spacing.S,
  },
})

const ScreenScheduleGrid = () => {
  const [search, setSearch] = useState('')
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()
  const { hasPermission } = usePermissions(companyId)

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: t('Schedules'),
    },
  ])

  const renderHeader = () => {
    return (
      <View style={styles.header}>
        <TextInput
          left="search"
          placeholder={t('Search schedule name')}
          right={
            search ? (
              <TouchableOpacity onPress={() => setSearch('')} testID="ScheduleGrid.Search.Clear">
                <Icon name="close" size="S" />
              </TouchableOpacity>
            ) : undefined
          }
          value={search}
          onChangeText={setSearch}
          style={styles.search}
          testID="ScheduleGrid.Search"
        />
        {hasPermission(AccessType.Update, 'workspace') && (
          <Link href={`/companies/${companyId}/workspaces/schedules/add`} asChild>
            <Button title={t('Add schedule')} left="plus" testID="ScheduleGrid.Add" />
          </Link>
        )}
      </View>
    )
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Schedules')} accessory={renderHeader()} />
      <View style={styles.content}>
        <Suspense fallback={<Grid.Skeleton hasChangeView itemElement={<ScheduleCard.Skeleton />} />}>
          <ScheduleGrid companyId={companyId} search={search} />
        </Suspense>
      </View>
    </View>
  )
}

export default ScreenScheduleGrid
